import { render, staticRenderFns } from "./LayoutWrapperDesktop.vue?vue&type=template&id=0c4096d7&"
import script from "./LayoutWrapperDesktop.vue?vue&type=script&lang=js&"
export * from "./LayoutWrapperDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports